import React from 'react';
import './index.css';

export default class GameOver extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.handleClick = this.handleClick.bind(this)
    this.backToMenu = this.backToMenu.bind(this)
  }

  handleClick (diff) {
    //const obstacle = document.getElementById('obstacle');
    //obstacle.style.left = "850px";
    //console.log('click')   
    //this.props.restart()  
    this.props.backToMenu()
  }

  backToMenu () {
    //this.props.restart() //restart in place broken
    this.props.backToMenu()
  }

  componentDidMount(){
    //window.addEventListener('keydown', this.backToMenu);
  }

  componentWillUnmount() {
    //window.removeEventListener('keydown', this.backToMenu);
  }

  render() {
    return (
        <div id='gameOverBtn' onClick={()=>this.handleClick()} >
          <h1>Game Over</h1>
          <h2><em>Click</em> to restart</h2>
        </div>   
    )
  }
}

//        <RandoLetter getKeyCode={this.getKeyCode} />


